import { Card, CardContent, Typography, Box, ThemeProvider, createTheme } from '@mui/material';
import l from '../../../lang';

const theme = createTheme({
  palette: {
    background: {
      paper: '#f5f5f5',
    },
    text: {
      primary: '#424242',
      secondary: '#616161',
    },
  },
  typography: {
    h5: {
      fontWeight: 400,
      fontSize: '1.5rem',
      marginBottom: '1rem',
    },
    body1: {
      fontSize: '1rem',
      lineHeight: 1.6,
    },
  },
});

interface SplitPaymentTermsProps {
  title?: string;
  htmlContent: string;
  maxHeight?: number;
}

const SplitPaymentTerms = ({
  title = l('split_payments.creation.terms_conditions'),
  htmlContent,
  maxHeight = 400,
}: SplitPaymentTermsProps) => {
  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ padding: 2, maxWidth: 800, margin: '0 auto' }}>
        <Card
          sx={{
            backgroundColor: '#e8e8e8',
            borderRadius: 3,
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            padding: 2,
            width: '100%',
          }}
        >
          <CardContent sx={{ padding: '24px !important' }}>
            <Typography
              variant="h5"
              component="h2"
              sx={{
                color: '#424242',
                fontWeight: 400,
                marginBottom: 2,
                fontSize: '1.2rem',
              }}
            >
              {title}
            </Typography>

            <Box
              sx={{
                maxHeight: `${maxHeight}px`,
                overflowY: 'auto',
                padding: '8px 0',
                '&::-webkit-scrollbar': {
                  width: '8px',
                },
                '&::-webkit-scrollbar-track': {
                  background: '#f1f1f1',
                  borderRadius: '4px',
                },
                '&::-webkit-scrollbar-thumb': {
                  background: '#c1c1c1',
                  borderRadius: '4px',
                  '&:hover': {
                    background: '#a8a8a8',
                  },
                },
                '& ul': {
                  margin: 0,
                  paddingLeft: '20px',
                  '& li': {
                    color: '#616161',
                    fontSize: '0.75rem',
                    lineHeight: 1.6,
                    marginBottom: '12px',
                    '&::marker': {
                      color: '#616161',
                    },
                  },
                },
                '& p': {
                  color: '#616161',
                  fontSize: '0.75rem',
                  lineHeight: 1.6,
                  margin: '12px 0',
                },
                '& h1, & h2, & h3, & h4, & h5, & h6': {
                  color: '#424242',
                  margin: '16px 0 8px 0',
                },
              }}
              dangerouslySetInnerHTML={{ __html: htmlContent }}
            />
          </CardContent>
        </Card>
      </Box>
    </ThemeProvider>
  );
};

export default SplitPaymentTerms;
